module.exports = __webpack_public_path__ + "static/IMG_0163-4a42e9cf68879a474052c03d23bc3564.png";